module.exports = __webpack_public_path__ + "static/img/wajuechanye.04a6ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom/wajuechanye.png
// module id = S+Rr
// module chunks = 1